export const BRAND = {
  name: 'School Management Portal',
  shortName: 'School Portal',
  description: 'School management records portal',
  logoSrc: '/logo.svg',
};
